export default [
  {
    path: "/deleteAccount",
    props: true,
    component: () => import("../DeleteAccount.vue")
  }
]
